/** @jsx jsx */

function GhostRedirect(props: any) {
  return null
}

export default GhostRedirect
